<template>
  <div class="international-pay-form-component">
    <el-form
      ref="innerPayForm"
      class="pay-form"
      :model="form"
      :rules="rules"
      label-width="420px"
    >
      <div class="title-label">
        <span>{{TS('Level_One_Label')}}</span>
      </div>

      <el-form-item :label="TS('Card_Type')">
        <img
          src="@/assets/images/order/payCard.jpg"
          height="40px"
        />
      </el-form-item>
      <el-form-item
        :label="TS('Card_Number')"
        prop="cardNo"
      >
        <el-input v-model.trim="form.cardNo" />
      </el-form-item>
      <el-form-item
        label="CVV2/CVC2/CAV2/CID："
        prop="cvv2"
      >
        <el-input v-model.trim="form.cvv2" />
      </el-form-item>

      <el-form-item
        :label="TS('Card_Lssuing_Bank')"
        prop="issuingBank"
      >
        <el-input v-model.trim="form.issuingBank" />
      </el-form-item>

      <el-form-item
        :label="TS('Expiry_Date')"
        prop="cardExpire"
      >
        <el-date-picker
          v-model.trim="form.cardExpire"
          type="month"
          value-format="yyyy-MM"
          :placeholder="TS('Expiry_Date_Placeholder')"
        />
      </el-form-item>

      <div class="title-label">
        <span>{{TS('Level_Two_Label')}}</span>
      </div>

      <el-form-item
        :label="TS('First_Name')"
        prop="firstName"
      >
        <el-input v-model.trim="form.firstName" />
      </el-form-item>

      <el-form-item
        :label="TS('Last_Name')"
        prop="lastName"
      >
        <el-input v-model.trim="form.lastName" />
      </el-form-item>

      <el-form-item
        :label="TS('Address')"
        prop="address"
      >
        <el-input
          type="textarea"
          v-model.trim="form.address"
        />
      </el-form-item>

      <el-form-item
        :label="TS('City_Town')"
        prop="city"
      >
        <el-input v-model.trim="form.city" />
      </el-form-item>

      <el-form-item
        :label="TS('Country_Region')"
        prop="country"
      >

        <el-select
          class="i18n-select"
          v-model.trim="form.country"
        >
          <el-option
            v-for="(o, i) in countryMap"
            :key="i"
            :label="TS(o)"
            :value="o"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="TS('State_Province')"
        prop="state"
      >
        <el-input v-model.trim="form.state" />
      </el-form-item>

      <el-form-item
        :label="TS('Postcode_Zip')"
        prop="zip"
      >
        <el-input v-model.trim="form.zip" />
      </el-form-item>

      <el-form-item
        :label="TS('Email')"
        prop="email"
      >
        <el-input v-model.trim="form.email" />
      </el-form-item>

      <el-form-item
        :label="TS('Phone')"
        prop="phone"
      >
        <el-input v-model.trim="form.phone" />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { I18n, countryMap } from '../config'

export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    rules: {
      type: Object,
      default: () => {
        return {}
      }
    },
    i18n: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countryMap
    }
  },
  created() {

  },
  methods: {
    TS(key) {
      return I18n(this.i18n, key)
    },
    validate(callback) {
      this.$refs.innerPayForm.validate((valid) => {
        callback(valid)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.international-pay-form-component {
  .title-label {
    padding-bottom: 7px;
    border-bottom: 1px solid #d1d1d1;
    margin-bottom: 30px;
    span {
      display: inline-block;
      height: 20px;
      line-height: 20px;
    }
  }
  .pay-form {
    /deep/ .el-input,
    .el-textarea {
      width: 300px;
    }
  }
}
</style>
